module.exports = __webpack_public_path__ + "static/media/darklogo.34f78e1d.png";